import { Box, Divider, Flex, Text } from '@chakra-ui/react'

import { FormModal } from '../../../components/FormModal'

interface ICaucaoInfoModalProps {
  isOpen: boolean
  onClose: () => void
  // When opened from the event series form, append the series-specific note.
  isSeries?: boolean
}

// Single source of truth for the "Entenda" caução explainer, shared by the event
// form and the event series form so both stay in sync.
export function CaucaoInfoModal({ isOpen, onClose, isSeries = false }: ICaucaoInfoModalProps) {
  return (
    <FormModal isOpen={isOpen} onClose={onClose} title="Como funcionam os ingressos com caução" cancelLabel="Entendi">
      <Flex direction="column" gap={4}>
        <Box>
          <Text fontSize="sm" fontWeight="700" color="gray.700">
            O que é
          </Text>
          <Text variant="caption" mt={1}>
            A caução é um valor reembolsável cobrado no checkout para garantir a presença. O participante recebe o valor
            de volta após fazer o check-in no evento.
          </Text>
        </Box>

        <Divider />

        <Box>
          <Text fontSize="sm" fontWeight="700" color="gray.700">
            Cobrança sempre à vista
          </Text>
          <Text variant="caption" mt={1}>
            Para garantir o estorno correto, a caução é cobrada à vista — PIX ou cartão de crédito em 1x. O parcelamento
            fica desabilitado quando há caução no carrinho, porque cobranças parceladas não podem ser estornadas
            individualmente pelo Asaas.
          </Text>
        </Box>

        <Divider />

        <Box>
          <Text fontSize="sm" fontWeight="700" color="gray.700">
            Reembolso (PIX × cartão)
          </Text>
          <Text variant="caption" mt={1}>
            O reembolso é solicitado pelo painel, em “Gerenciar Cauções” → “Reembolsar Elegíveis”, para quem fez
            check-in. No PIX o estorno cai em minutos; no cartão pode levar alguns dias úteis para aparecer na fatura
            (prazo da operadora).
          </Text>
        </Box>

        <Divider />

        <Box>
          <Text fontSize="sm" fontWeight="700" color="gray.700">
            Valor e isenção de taxa
          </Text>
          <Text variant="caption" mt={1}>
            A caução deve ser R$ 0,00 (totalmente gratuito) ou no mínimo R$ 5,00. Ela é isenta da taxa de 10% — o
            participante paga exatamente o valor configurado.
            {isSeries && ' Em séries, o valor vale para todas as edições do ingresso.'}
          </Text>
        </Box>

        <Divider />

        <Box>
          <Text fontSize="sm" fontWeight="700" color="gray.700">
            Status “Aguardando confirmação”
          </Text>
          <Text variant="caption" mt={1}>
            Após solicitar, o status fica “Aguardando confirmação” até o Asaas confirmar a liquidação. O sistema
            reconcilia automaticamente de tempos em tempos, e você pode forçar a checagem com o botão “Reverificar
            status” em Gerenciar Cauções.
          </Text>
        </Box>
      </Flex>
    </FormModal>
  )
}
